import './styles/App.css'
import Input from './components/input'
import Title from './components/title'
import Result from './components/result'
function App() {
    return (
        <>
            <Title />
            <Input />
            <Result />
            <footer></footer>
        </>);
}

export default App;